import React from "react";
import "./CustomerReviews.css";

const reviews = [
  {
    id: 1,
    name: "Dr. Kaustav Dey",
    hospital: "Nishamani Multispeciality Hospital, Cuttack, Odisha",
    video: "../assets/review/review1.mp4"
  },
  // {
  //   id: 2,
  //   name: "Dr. Riyaz Mujawar",
  //   hospital: "Aryan Heart Care, Miraj",
  //   video: "/reviews/review2.mp4"
  // },
  // {
  //   id: 3,
  //   name: "Dr. Hemant Magar",
  //   hospital: "Sushrut Hospital, Phaltan",
  //   video: "/reviews/review3.mp4"
  // },
];

function CustomerReviews() {
  return (
    <div className="reviews-page">
      <div className="reviews-hero">
        <h1>Doctors Reviews</h1>
        <p>
          Trusted by hospitals, surgeons, and healthcare institutions across
          India for Modular OT and hospital infrastructure solutions.
        </p>
      </div>

      <div className="reviews-grid">
        {reviews.map((review) => (
          <div key={review.id} className="review-card">

            {/* VIDEO */}
            <div className="review-video">
              <video controls>
                <source src={review.video} type="video/mp4" />
                Your browser does not support video tag.
              </video>
            </div>

            {/* INFO */}
            <h3>{review.name}</h3>
            <span>{review.hospital}</span>

          </div>
        ))}
      </div>
    </div>
  );
}

export default CustomerReviews;